/**
 * Which sport glyph to draw. One per distinct icon, not per sport — sports
 * that share equipment share a glyph (floorball and curling draw the stick).
 */
export type SportIconKey =
  | 'hockey'
  | 'soccer'
  | 'handball'
  | 'tennis'
  | 'baseball'
  | 'basketball'
  | 'volleyball'
  | 'football'
  | 'rugby'
  | 'waterPolo'
  | 'cricket'
  | 'esports'
  | 'generic'

/**
 * The glyph for a sport's display name ("Ice Hockey", "Pickleball"), matched
 * case-insensitively. Mirrors mobile's `getMaterialIconBySportName`, so a sport
 * reads the same on both platforms; unknown sports fall back to `generic`.
 */
export const getSportIconKey = (
  sportName: string | null | undefined
): SportIconKey => {
  switch ((sportName ?? '').trim().toLowerCase()) {
    case 'ball hockey':
    case 'ice hockey':
    case 'hockey':
    case 'floorball':
    case 'field hockey':
    case 'curling':
      return 'hockey'
    case 'soccer':
    case 'kickball':
    case 'futsal':
    case 'futsol':
      return 'soccer'
    case 'lacrosse':
      return 'handball'
    case 'badminton':
    case 'pickleball':
    case 'tennis':
      return 'tennis'
    case 'baseball':
    case 'softball':
      return 'baseball'
    case 'basketball':
      return 'basketball'
    case 'dodgeball':
    case 'volleyball':
      return 'volleyball'
    case 'football':
    case 'flag football':
      return 'football'
    case 'rugby':
      return 'rugby'
    case 'water polo':
      return 'waterPolo'
    case 'cricket':
      return 'cricket'
    case 'esports':
      return 'esports'
    default:
      return 'generic'
  }
}
